import { rootReducer } from './rootReducer';
import { createStore as cS, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
export function createStore(middleware, initialState) {
    if (middleware) {
        return cS(rootReducer, initialState, composeWithDevTools(applyMiddleware(middleware)));
    }
    // We don't use middleware for testing.
    return cS(rootReducer, initialState);
}
